import request from './request';
import { filterUndefindObj } from '@src/utils/dataHandlingFunc';

// 提交客户端问题
export const submitProblem = async ({
  accessMode,
  areaCode,
  corporateName,
  describe,
  email,
  phone,
  region,
  time,
  userName,
  timeZone,
  accountNumber
}) => {
  const newParams = filterUndefindObj({
    customer_name: userName,
    email,
    company_name: corporateName,
    region,
    phone: `${areaCode} ${phone}`,
    problem: describe?.replace(/\n/g, '<br />'),
    problem_time: `${time}  ${timeZone}`,
    access_mode: accessMode,
    powerchina_account: accountNumber
    // attachments: file || []
  });

  const formData = new FormData();
  Object.keys(newParams).forEach(item => {
    formData.append(item, newParams[item]);
  });

  const res = await request({
    method: 'post',
    url: '/special_api/vpnclient/consult',
    propsType: 'custom',
    data: formData
  });

  return !!res;
}

